// FileReader.readAsDataURL as a promise: "data:<mime>;base64,…", exactly the
// inlined data URL the socket expects as file_data. Shared by the file picker
// (images, PDFs) and the voice recorder.
export function readBlobAsDataUrl(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result));
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(blob);
  });
}
